module.exports = __webpack_public_path__ + "media/images/mastercard-logo-fbf6c823711058cb8fcb59bb340060a8.png";